import type { RouteRecordRaw } from 'vue-router'
import { RouterView } from 'vue-router'

export const deliveryRoutes: RouteRecordRaw[] = [
  {
    path: '/delivery',
    component: RouterView,
    meta: {
      locationTypes: ['location', 'singleLocation']
    },
    children: [
      {
        name: 'delivery',
        path: '',
        component: () => import('./views/DeliveryView.vue')
      },
      {
        name: 'ordersLimit',
        path: '/orders-limit',
        component: () => import('./views/OrderingLimitsView.vue')
      }
    ]
  }
]
